function makeList(...args) {
  args.pop();
  return args;
}

export default makeList;
